'use strict';

import SimpleSAMLLogout from './logout.js';

ready(function () {
    new SimpleSAMLLogout(document.body.id);
});
